import { useState } from "react";
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper";
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar";
import TrainingModules from "../../../../components/AdminPortalComponents/TrainingAndResources/TrainingModules/TrainingModules";
import AddNewTrainingModule from "../../../../components/AdminPortalComponents/TrainingAndResources/TrainingModules/AddNewTrainingModule/AddNewTrainingModule";
import ResourceManagement from "../../../../components/AdminPortalComponents/TrainingAndResources/ResourceManagement/ResourceManagement";
import AddNewResource from "../../../../components/AdminPortalComponents/TrainingAndResources/ResourceManagement/AddNewResource/AddNewResource";

const TrainingAndResources = () => {

  const tabs = [
    { key: 'trainingModules', label: 'Training Modules' },
    { key: 'resourceManagement', label: 'Resource Management' },
    { key: 'webinar', label: 'Webinar' },
    { key: 'feedbackManagement', label: 'Feedback Management' },
    { key: 'policyAndProcedure', label: 'Policy And Procedure' },
  ]

  const [activeTab, setActiveTab] = useState(tabs[0].key)
  const [newModuleCreation, setNewModuleCreation] = useState(false)
  const [addNewResource, setAddNewResource] = useState(false)

  const renderTabs = {
    trainingModules: newModuleCreation ? <AddNewTrainingModule setNewModuleCreation={setNewModuleCreation} /> : <TrainingModules setNewModuleCreation={setNewModuleCreation} />,
    resourceManagement: addNewResource ? <AddNewResource setAddNewResource={setAddNewResource} /> : <ResourceManagement setAddNewResource={setAddNewResource} />,
    webinar: 'Webinar',
    feedbackManagement: 'Feedback',
    policyAndProcedure: 'Policy',
  }

  return (
    <LightGrayBgWrapper>

      <div className="shadow">
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="white" />
      </div>

      {renderTabs[activeTab] || null}

    </LightGrayBgWrapper>
  );
};

export default TrainingAndResources;